<script lang="ts" setup>
// #左圖右文
import { type Text } from '@/utils/types/TextEditor'
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const textData = ref()
const imgData = ref()

if (props.data) {
  const text: Ref<Text> = ref(props.data.text)
  const img: Ref<Image> = ref(props.data.image)
  textData.value = text.value
  imgData.value = img.value
}
</script>

<template>
  <div class="area">
    <figure class="area__pic">
      <Nimg :src="imgData?.link" :title="imgData?.title" :alt="imgData?.alt" format="webp" />
    </figure>
    <div class="area__right">
      <div class="area__text" v-html="textData"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.area {
  display: flex;
  align-items: center;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  @include max-media(580) {
    flex-direction: column;
  }

  &__pic,
  &__right {
    width: 50%;

    @include max-media(580) {
      width: 100%;
    }
  }

  &__pic {
    img {
      display: block;
      width: 100%;
    }
  }

  &__right {
    padding-left: 15%;

    @include max-media(580) {
      padding: toRem(30) toRem(30) 0;
    }
  }

  &__title {
    margin-bottom: toRem(15);
    font-weight: 500;
    font-size: toRem(28);
    line-height: 1.3;

    @include max-media(580) {
      font-size: toRem(22);
    }
  }
}
</style>
